
(function () {
  if (window.RegistaBuyLookLoaded) return;
  window.RegistaBuyLookLoaded = true;

  function normalize(text) {
    return String(text || '').trim().toLowerCase();
  }

  function getVariantSize(product, variant) {
    var optionNames = product.options || [];
    var sizeIndex = optionNames.findIndex(function (name) {
      var n = normalize(name);
      return n === 'size' || n === 'Size' || n.includes('size') || n.includes('Size');
    });

    if (sizeIndex > -1 && variant.options && variant.options[sizeIndex]) {
      return variant.options[sizeIndex];
    }

    if (variant.option1 && /^(xs|s|m|l|xl|xxl|3xl|4xl|5xl)$/i.test(String(variant.option1))) return variant.option1;
    if (variant.option2 && /^(xs|s|m|l|xl|xxl|3xl|4xl|5xl)$/i.test(String(variant.option2))) return variant.option2;
    if (variant.option3 && /^(xs|m|s|l|xl|xxl|3xl|4xl|5xl)$/i.test(String(variant.option3))) return variant.option3;

    return variant.title || 'One size';
  }

  function uniqueSizesForProduct(product) {
    var seen = {};
    var sizes = [];

    (product.variants || []).forEach(function (variant) {
      if (!variant.available) return;
      var size = getVariantSize(product, variant);
      var key = normalize(size);
      if (seen[key]) return;
      seen[key] = true;
      sizes.push({ label: size, variantId: variant.id });
    });

    return sizes;
  }

  function findVariantBySize(product, sizeLabel) {
    var target = normalize(sizeLabel);
    return (product.variants || []).find(function (variant) {
      return variant.available && normalize(getVariantSize(product, variant)) === target;
    });
  }

  function setMessage(root, text, isError) {
    var message = root.querySelector('[data-regista-buy-look-message]');
    if (!message && root.__registaBuyLookModal) {
      message = root.__registaBuyLookModal.querySelector('[data-regista-buy-look-message]');
    }
    if (!message) return;
    message.textContent = text || '';
    message.classList.toggle('is-error', !!isError);
  }

  function queryInRootAndModal(root, selector) {
    var item = root.querySelector(selector);
    if (!item && root.__registaBuyLookModal) item = root.__registaBuyLookModal.querySelector(selector);
    return item;
  }

  function queryAllInRootAndModal(root, selector) {
    var items = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.__registaBuyLookModal) {
      items = items.concat(Array.prototype.slice.call(root.__registaBuyLookModal.querySelectorAll(selector)));
    }

    return items.filter(function (item, index, list) {
      return list.indexOf(item) === index;
    });
  }

  function portalModal(root, modal) {
    if (!modal) return;
    root.__registaBuyLookModal = modal;
    if (modal.dataset.portalReady === 'true') return;
    document.body.appendChild(modal);
    modal.dataset.portalReady = 'true';
  }

  function rememberLookDiscount(code) {
    try {
      window.sessionStorage.setItem('regista-look-discount-code', code || 'LOOK10');
    } catch (error) {}
  }

  function getRememberedDiscountCode() {
    try {
      return window.sessionStorage.getItem('regista-look-discount-code') || '';
    } catch (error) {
      return '';
    }
  }

  function redirectWithDiscount(code, redirectPath) {
    if (!code) return false;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + (redirectPath || '/cart');
    return true;
  }

  function refreshCartUI() {
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {}
  }

  async function addItemsToCart(items) {
    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    });

    if (response.ok) return response.json();

    var batchError;
    try { batchError = await response.json(); } catch (error) { batchError = {}; }

    // If Shopify refuses the multi-add because of one edge case, add the valid items one by one.
    // This keeps the UX from failing completely and fixes cases where only one item used to make it through.
    var added = [];
    for (var i = 0; i < items.length; i += 1) {
      var singleResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: items[i].id, quantity: items[i].quantity || 1, properties: items[i].properties || {} })
      });

      if (!singleResponse.ok) {
        var singleError;
        try { singleError = await singleResponse.json(); } catch (error) { singleError = batchError; }
        throw new Error(singleError.description || singleError.message || 'cart-add-failed');
      }

      try { added.push(await singleResponse.json()); } catch (error) {}
    }

    return added;
  }

  function initBuyLook(root) {
    if (!root || root.dataset.registaBuyLookReady === 'true') return;
    root.dataset.registaBuyLookReady = 'true';

    var dataScript = root.querySelector('[data-regista-buy-look-data]');
    var data;

    try {
      data = JSON.parse(dataScript ? dataScript.textContent : '{}');
    } catch (error) {
      return;
    }

    var products = data.products || [];
    var modal = root.querySelector('[data-regista-buy-look-modal]');
    root.__registaBuyLookModal = modal || null;
    var openButton = root.querySelector('[data-regista-buy-look-open]');
    var previouslyFocused = null;

    products.forEach(function (product) {
      var selects = queryAllInRootAndModal(root, '[data-regista-look-variant-select][data-product-id="' + product.id + '"]');
      if (!selects.length) return;

      selects.forEach(function (select) {
        if (select.dataset.registaOptionsReady === 'true') return;
        select.dataset.registaOptionsReady = 'true';

        var sizes = uniqueSizesForProduct(product);
        sizes.forEach(function (size) {
          var option = document.createElement('option');
          option.value = size.label;
          option.textContent = size.label;
          select.appendChild(option);
        });

        var selectedVariant = (product.variants || []).find(function (variant) {
          return String(variant.id) === String(product.selectedVariantId) && variant.available;
        });

        if (selectedVariant) {
          select.value = getVariantSize(product, selectedVariant);
        } else if (sizes.length === 1) {
          select.value = sizes[0].label;
        }
      });
    });

    function openModal() {
      portalModal(root, modal);
      previouslyFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      var firstFocusable = modal.querySelector('button:not([disabled]), select:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) window.setTimeout(function () { firstFocusable.focus(); }, 0);
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
    }

    if (openButton) openButton.addEventListener('click', openModal);

    queryAllInRootAndModal(root, '[data-regista-buy-look-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target && event.target.hasAttribute('data-regista-buy-look-close')) closeModal();
      });
    }

    var escapeKeyHandler = function (event) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key !== 'Tab') return;

      var focusable = Array.prototype.slice.call(modal.querySelectorAll('button:not([disabled]), select:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
        .filter(function (item) { return item.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };
    root.__registaBuyLookEscapeKey = escapeKeyHandler;
    document.addEventListener('keydown', escapeKeyHandler);

    queryAllInRootAndModal(root, '[data-regista-buy-look-add]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var items = [];

        for (var i = 0; i < products.length; i += 1) {
          var product = products[i];
          var selectContainer = button.closest('[data-regista-buy-look]') || root;
          var select = selectContainer.querySelector('[data-regista-look-variant-select][data-product-id="' + product.id + '"]');

          if (!select) select = queryInRootAndModal(root, '[data-regista-look-variant-select][data-product-id="' + product.id + '"]');
          var size = select ? select.value : '';

          if (!size) {
            setMessage(root, 'Select a size for every item in the look.', true);
            if (select) select.focus();
            return;
          }

          var variant = findVariantBySize(product, size);
          if (!variant) {
            setMessage(root, 'One of your selected sizes is no longer available. Choose another size.', true);
            if (select) select.focus();
            return;
          }

          items.push({
            id: variant.id,
            quantity: 1,
            properties: {
              '_Regista Look': 'LOOK10',
              '_Look discount': '10%'
            }
          });
        }

        if (!items.length) return;

        button.disabled = true;
        var originalText = button.textContent;
        button.textContent = 'Adding the complete look to your basket...';
        setMessage(root, '', false);

        try {
          await addItemsToCart(items);

          var code = data.discountCode || 'LOOK10';
          rememberLookDiscount(code);
          if (window.RegistaCartHold && typeof window.RegistaCartHold.start === 'function') {
            window.RegistaCartHold.start(30);
          }

          refreshCartUI();
          setMessage(root, 'The look has been added. Your discount will be applied in the basket or at checkout.', false);
          button.textContent = 'Look added to basket';

          window.setTimeout(function () {
            button.disabled = false;
            button.textContent = originalText;
          }, 2200);
        } catch (error) {
          button.disabled = false;
          button.textContent = originalText;
          setMessage(root, error.message || 'We could not add the complete look. Please try again in a moment.', true);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-regista-buy-look]').forEach(initBuyLook);
  }

  function discountCartLinks() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;

      var code = getRememberedDiscountCode();
      if (!code) return;

      var checkoutButton = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (checkoutButton) {
        event.preventDefault();
        redirectWithDiscount(code, '/checkout');
        return;
      }

      var link = target.closest('a[href]');
      if (!link) return;

      var href = link.getAttribute('href') || '';
      if (!/(^|\/)cart(\?|#|$)/.test(href)) return;

      event.preventDefault();
      redirectWithDiscount(code, '/cart');
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;

      var code = getRememberedDiscountCode();
      if (!code) return;

      var submitter = event.submitter || document.activeElement;
      var isCheckout = submitter && submitter.name === 'checkout';
      if (!isCheckout) return;

      event.preventDefault();
      redirectWithDiscount(code, '/checkout');
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      discountCartLinks();
    });
  } else {
    initAll();
    discountCartLinks();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event || !event.target) return;

    event.target.querySelectorAll('[data-regista-buy-look]').forEach(function (root) {
      if (root.__registaBuyLookEscapeKey) {
        document.removeEventListener('keydown', root.__registaBuyLookEscapeKey);
        delete root.__registaBuyLookEscapeKey;
      }

      var modal = root.__registaBuyLookModal;
      if (modal && modal.parentNode === document.body && modal.dataset.portalReady === 'true') {
        modal.remove();
      }

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    });
  });
})();
